<template>
  <div id="problems-list" class="purple-box">
    <div class="area-header --uppercase">{{ $t('ui.suggestions') }}</div>
    <div v-if="warnings.length" id="problems">
      <component
        v-for="(warning, i) in warnings"
        :key="i"
        v-bind:is="warning.componentName"
        :data="warning.data" />
    </div>
    <div v-else >
      <div id="no-warnings-star-rating">
        <span v-for="n in 5" :key="n" class="material-icons">star_rate</span>
      </div>
      <div id="no-warnings-tag">{{ $t('ui.noWarnings') }}</div>
    </div>
  </div>  
</template>

<script>
import WarningForwardMovement from './WarningForwardMovement'
import WarningOverlap from './WarningOverlap'
import WarningResponsibilities from './WarningResponsibilities'
import WarningTacticalRisk from './WarningTacticalRisk'
import WarningTransitionPartnerships from "./WarningTransitionPartnerships.vue";
import WarningTransitionRisk from "./WarningTransitionRisk.vue";
import WarningMissingPartnership from "./WarningMissingPartnership";
import WarningNoSuitablePartnership from "./WarningNoSuitablePartnership";
import WarningDutiesCount from "./WarningDutiesCount";
import WarningUnsuitableInstruction from './WarningUnsuitableInstruction';
import WarningUnsuitableStyle from './WarningUnsuitableStyle';

export default {
  components: {
    WarningForwardMovement,
    WarningOverlap,
    WarningResponsibilities,
    WarningTacticalRisk,
    WarningTransitionPartnerships,
    WarningTransitionRisk,
    WarningMissingPartnership,
    WarningNoSuitablePartnership,
    WarningDutiesCount,
    WarningUnsuitableInstruction,
    WarningUnsuitableStyle,
  },

  computed: {
    warnings () {
      return this.$store.getters.warnings;
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .mobile-hide {
    display: none;
  }
}
</style>
